const COMMENT_ITEMS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20portrait%20avatar%20illustration%20of%20a%20young%20person%2C%20warm%20coral%20and%20cream%20tones%2C%20flat%20design%2C%20simple%20geometric%20style%2C%20clean%20background&width=96&height=96&seq=avatar-cmt-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我真的是从头吃到尾，细节太丰富了！小编辛苦了，整理得很全面。建议大家都来看看时间线，简直比电视剧还精彩。',
    likes: '2.3k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20style%20portrait%20avatar%20of%20a%20female%20character%2C%20warm%20peach%20and%20cream%20colors%2C%20simple%20geometric%20design%2C%20clean%20illustration%20style&width=96&height=96&seq=avatar-cmt-02&orientation=squarish',
    name: '八卦小能手',
    time: '3小时前',
    content: '52吃瓜网真的一直是我最常看的八卦平台，更新又快又全。这次的专题整理得很有条理，给编辑部点赞！',
    likes: '1.8k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20flat%20portrait%20avatar%20illustration%20of%20a%20male%20character%2C%20warm%20golden%20and%20cream%20tones%2C%20minimalist%20geometric%20design%2C%20clean%20background&width=96&height=96&seq=avatar-cmt-03&orientation=squarish',
    name: '理性吃瓜人',
    time: '5小时前',
    content: '看了这么多八卦平台，还是这里的信息最靠谱。有图有真相，时间线清晰，不会为了流量瞎编。推荐给身边所有朋友了。',
    likes: '1.5k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Flat%20design%20minimalist%20portrait%20avatar%2C%20young%20female%20character%2C%20warm%20rose%20and%20cream%20color%20palette%2C%20simple%20geometric%20shapes%2C%20clean%20illustration&width=96&height=96&seq=avatar-cmt-04&orientation=squarish',
    name: '追星少女本女',
    time: '6小时前',
    content: '每天上班第一件事就是打开52吃瓜网看看有什么新瓜哈哈哈，已经成了固定routine了。国际频道也超级棒！',
    likes: '987',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            真实声音
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">读者热评</h2>
          <p className="text-sm text-foreground-500 mt-2">千万吃瓜群众的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {COMMENT_ITEMS.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                  }}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-1.5">{c.content}</p>
                </div>
              </div>
              <div className="flex items-center gap-1 text-xs text-foreground-400 pl-13">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}